import { createAPI } from '@/request.js'

// 加盟申请列表
export const joinApplicationList = data => createAPI('/api/join/application/query.mt', 'post', data)

// 处理加盟申请
export const editJoinApplication = data => createAPI('/api/join/application/deal.mt', 'post', data)
